export const name = 'constants';

export {
  APP_REGION_ENV_KEYS,
  DEFAULT_APP_REGION,
  getAppRegionState,
  type AppRegionEnv,
  type AppRegionState,
} from './constants/app-region';

export { HELP_CENTER_URL, helpArticleUrl } from './constants/helpCenter';

export {
  AI_LOGISTICS_SUGGESTIONS,
  AI_MESSAGE_ROLES,
  AI_OBJECTIVE_SUGGESTIONS,
  AI_RECRUITMENT_SUGGESTIONS,
  AI_SUGGESTION_TYPES,
  audienceStepRoute,
  BLINDING_TYPE_ID,
  COGNITO_ERROR_NAMES,
  COMMUNITY_SLUGS,
  DEFAULT_COMMUNITY_SLUG,
  DEFAULT_CONFIDENCE_LEVEL_LABEL,
  DEFAULT_CONFIDENCE_LEVEL_PERCENT,
  DEFAULT_CUSTOM_CRITERIA_LABEL,
  DEFAULT_SIGNIFICANCE_LEVEL,
  MAX_SIGNIFICANCE_LEVEL,
  MIN_SIGNIFICANCE_LEVEL,
  SIGNIFICANCE_MIN_RESPONSE_COUNT,
  isBaseLargeEnough,
  isSignificanceLevelInRange,
  toConfidenceLevelPercent,
  deriveProjectSubject,
  isProjectSubject,
  type DerivedProjectSubject,
  EXPERIENCE_IDS,
  ISO_COUNTRY_CODES,
  HANDLING_PREFERENCE_KEYS,
  KEYS,
  resolveNewProjectRoute,
  type NewProjectRoute,
  resolveProjectSetupRoute,
  ORGANIZATION_ROLES,
  PERISHABLE_TYPE_ID,
  PROJECT_SUBJECT_OPTIONS,
  QUESTION_LABELS,
  QUESTION_TYPES,
  type CommunitySlug,
  type QuestionType,
  type QuestionTypeValue,
  type RecruitSource,
  RECRUIT_SOURCE,
  TASK_TYPES,
  TEST_TYPES,
  WINDOW_EVENTS,
  PERSONA_CHAT_ACCEPTED_FILE_TYPES,
  PERSONA_CHAT_ALLOWED_IMAGE_FORMAT_LABELS,
  PERSONA_CHAT_ALLOWED_IMAGE_MIME_TYPES,
  PERSONA_CHAT_ALLOWED_IMAGE_MIME_TYPES_SET,
  PERSONA_CHAT_ATTACHMENT_OVERFLOW_MESSAGE,
  PERSONA_CHAT_DROP_GUIDANCE_MULTIPLE,
  PERSONA_CHAT_DROP_GUIDANCE_SINGLE,
  PERSONA_CHAT_IMAGE_EXTENSION_TO_MIME,
  PERSONA_CHAT_MAX_IMAGE_BYTES,
  PERSONA_CHAT_MAX_IMAGE_FILES,
  PERSONA_CHAT_CARRIED_FORWARD_IMAGE_PLACEHOLDER,
  PERSONA_CHAT_IMAGE_JPEG_QUALITY,
  PERSONA_CHAT_IMAGE_MAX_DIMENSION_PX,
  PERSONA_CHAT_IMAGE_OUTPUT_MIME_TYPE,
  assignPersonaChatImageIndices,
  buildPersonaChatImageRefs,
  getPersonaChatImageLabel,
  getPersonaChatImageLabels,
  type PersonaChatImageRef,
  SHIPMENT_REQUIREMENT_TYPES,
  STEP_TYPES,
} from './constants';
